export default __webpack_public_path__ + "static/media/hands.7926e102.jpg";